<template>
  <div class="lineup bg-color overflow-hidden">
    <vue-headful :title="doctitle" />
    <!-- OLD TAG PICKER -->
    <!--   <div
      v-if="this.status != 'sessions'"
      class="container tags-container bg-color"
    >
      <h1 class="big-headline pt-5 text-color-dark">
        Pick their brains. Gain their knowledge
      </h1>
      <h5 class="text-color-dark">Pick your areas of interest below</h5>
      <div v-if="loadtags" class="row justify-content-center loading-tags">
        <Spinner></Spinner>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-12 text-right select-all mt-5 mt-lg-0">
            <a
              v-if="this.tags.length !== this.tagschoosen.length"
              href="#"
              v-on:click="selectAllTags()"
            >
              Select all
            </a>
            <span
              v-if="
                this.tagschoosen.length > 0 &&
                this.tags.length !== this.tagschoosen.length
              "
            >
              |
            </span>
            <a
              v-if="this.tagschoosen.length > 0"
              href="#"
              v-on:click="deselectAllTags()"
            >
              Deselect all
            </a>
          </div>

          <div class="tags row col-12">
            <div
              class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6"
              v-for="tag in tags"
              :key="tag.index"
            >
              <div
                v-on:click="setTag(tag)"
                v-bind:class="[setActiveTag(tag)]"
                class="tag text-center text-color-dark"
              >
                {{ tag.org }}
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center pb-5">
          <button
            v-on:click="setStatus('sessions')"
            v-bind:class="[setActiveNext()]"
            class="btn btn-1"
          >
            <i class="material-icons">done</i>
          </button>
        </div>
      </div>
    </div> -->
    <!-- OLD TAG PICKER END -->

    <div v-if="this.status === 'sessions'">
      <div class="bg-mobile"></div>
      <div class="background">
        <b-img
          src="https://res.cloudinary.com/oredev/image/upload/v1715163928/2024/Two-blobs-yellow.gif"
          fluid
          class="blob-left"
        ></b-img>
        <b-img
          src="https://res.cloudinary.com/oredev/image/upload/v1714049018/2024/Asset_38_3x.png"
          fluid
          class="red-square"
        ></b-img>
        <div class="container-fluid container-height position-relative">
          <div class="row align-items-end row-height">
            <div class="col-12 lg-6 offset-lg-1">
              <h1
                class="d-none d-sm-block text-color-dark big-headline text-lg-left"
              >
                This year's speakers
              </h1>
              <h1
                class="d-block d-sm-none text-color-dark big-headline text-lg-left"
              >
                This year's <br />
                speakers
              </h1>
              <b-img
                style="position: absolute; top: 12%; right: 9%; width: 16%"
                class="d-block d-xl-none"
                fluid
                src="https://res.cloudinary.com/oredev/image/upload/v1715523769/2024/green-arrow_copy.gif"
              ></b-img>
            </div>
          </div>
          <!--  TAGS/TRACKS PICKER -->
          <div class="row mt-5 mt-sm-0 mb-5">
            <div class="col-12 col-lg-5 offset-lg-1 tags-choosen">
              <div class="mb-4 mt-5 mt-sm-0" style="font-weight: 300">
                <span
                  class="pointer select"
                  :style="
                    tagschoosen.length == 12
                      ? 'font-weight: 500; text-decoration: underline'
                      : ''
                  "
                  @click="selectAllTags()"
                  >Select All</span
                >
                <!--       <button
                class="tags-add text-center"
                @click="selectAllTags()"
                :class="
                  tagschoosen.length === tags.length ? 'disabled-all' : ''
                "
                :disabled="tagschoosen.length === tags.length"
              >
                <small>All</small>
              </button> -->

                <span
                  class="ml-3 ml-sm-5 pointer select"
                  @click="deselectAllTags()"
                  :style="
                    tagschoosen.length == 0
                      ? 'font-weight: 500; text-decoration: underline'
                      : ''
                  "
                  >Clear All</span
                >
                <span class="ml-3 ml-sm-5"
                  >Categories selected: {{ tagschoosen.length }}</span
                >

                <!--         <div
                class="tags-add text-center pl-0 pr-0"
                :class="tagschoosen.length === 0 ? 'disabled-all' : ''"
                href="#"
                v-on:click="deselectAllTags()"
              >
                <small>Clear</small>
              </div> -->
              </div>
              <div class="tags d-flex flex-wrap">
                <div
                  class="cat-tag tag-choosen text-center"
                  v-for="tag in tags"
                  :key="tag.index"
                  @click="setTag(tag)"
                  :class="[setActiveTag(tag)]"
                  :style="'border-color:' + tag.color + '; color: ' + tag.color"
                  style="margin: 2px"
                >
                  <div class="text-center" style="line-height: 22px">
                    {{ getTag(tag.org) }}
                  </div>
                </div>
              </div>

              <!--   <div
                v-if="speaker"
                v-on:click="resetSpeaker()"
                class="tag-choosen text-center active speaker"
              >
                <span>
                  {{ speaker.speakerFirstName }}
                  {{ speaker.speakerLastName }}
                </span>

                <i class="material-icons">clear</i>
              </div> -->
            </div>
            <div class="col-12 col-lg-2">
              <!--        <img
                src="https://res.cloudinary.com/oredev/image/upload/v1684917754/ezgif.com-optimize.gif"
                class="fluid space-man"
                alt="space-man"
              /> -->
            </div>
          </div>
          <b-img
            style="position: absolute; top: 157%; right: 50%; width: 6%"
            class="d-none d-xl-block"
            fluid
            src="https://res.cloudinary.com/oredev/image/upload/v1715523769/2024/green-arrow_copy.gif"
          ></b-img>
        </div>
      </div>
      <!--       <div v-if="loading" class="row justify-content-center loading-tags">
        <b-img
          src="https://res.cloudinary.com/oredev/image/upload/v1715523768/2024/loading_copy.gif"
          fluid
        ></b-img>
      </div> -->
      <div class="container pt-4">
        <!--  SPEAKER CARD -->
        <div
          hidden
          v-if="this.speakername"
          class="speaker-single bg-green pb-3 pr-3 pl-3"
        >
          <b-row no-gutters class="mt-5 justify-content-md-center">
            <div class="col-md-4 col-sm-12 text-center">
              <!-- <div id="scroll-anchor"></div> -->
              <div v-if="speaker && speaker.speakerImageURL">
                <img
                  class="mb-4 speaker-image speakerImage"
                  :key="myKey"
                  :src="speaker.speakerImageURL"
                  alt=""
                />
              </div>
            </div>

            <div v-if="speaker" class="col-md-8 col-sm-12">
              <div class="p-3 pb-4 5 bg-green text-color-dark mt-3">
                <h4 class="text-color-dark pb-2 speaker-name">
                  {{ this.speaker.speakerFirstName }}
                  {{ this.speaker.speakerLastName }}
                </h4>
                <a
                  v-if="speaker.speakerTwitter"
                  class="mb-2 d-block"
                  style="
                    cursor: pointer;
                    text-decoration: none !important;
                    color: #292929 !important;
                  "
                  :href="'http://twitter.com/' + speaker.speakerTwitter"
                >
                  {{ speaker.speakerTwitter }}
                </a>

                <p class="text-left">
                  {{ speaker.speakerBiography }}
                </p>
              </div>
            </div>
          </b-row>

          <!--  SPEAKER SESSIONS -->
          <div v-if="speaker && speaker.speakerSession">
            <div
              v-for="session in speaker.speakerSession"
              v-bind:class="[setActiveSchedule(session.sId)]"
              class="row session"
              :key="session.index"
            >
              <div class="col-lg-9 col-8 main speaker-bg">
                <div class="row">
                  <div class="col-6 speaker">
                    {{ getDay(session.scheduleDay) }} {{ session.scheduleTime }}
                  </div>
                  <div
                    v-on:click="toggleText(session.sId)"
                    class="col-12 session-info pb-3"
                  >
                    <h5>
                      <span class="session-title">{{ session.title }}</span>
                    </h5>
                  </div>
                </div>
                <div :data-id="session.sId" class="col-12 session-text hidden">
                  <h6>Key takeaways</h6>
                  <ul>
                    <li v-if="session.takeAway1">{{ session.takeAway1 }}</li>
                    <li v-if="session.takeAway2">{{ session.takeAway2 }}</li>
                    <li v-if="session.takeAway3">{{ session.takeAway3 }}</li>
                    <li v-if="session.takeAway4">{{ session.takeAway4 }}</li>
                  </ul>
                  <p class="text-color-dark">
                    {{ session.description }}
                  </p>
                  <div class="open-in-new">
                    <a
                      target="_blank"
                      v-if="session.url"
                      v-bind:href="'/sessions/' + session.url"
                    >
                      <i class="material-icons">open_in_new</i>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="col-lg-3 col-4 add-schedule speaker-bg"
                v-on:click="setSchedule(session.sId, $event)"
              >
                <b-button
                  class="btn btn-1 add mt-3"
                  :class="setActiveSchedule(session.sId, true)"
                  >{{ addOrRemove(session.sId) }}</b-button
                >
              </div>
            </div>
          </div>
        </div>

        <!--  NO TAGS CHOSEN -->
        <!--         <div v-if="tagschoosen.length == 0" class="pt-3 pb-5">
          <b-row>
            <b-col cols="12">
              <h6 class="text-color-dark text-center">
                Game over, select tracks to see speakers
                <a @click="selectAllTags()" href="#" rel="noopener noreferrer"
                  >(show all)</a
                >
              </h6>
              <div class="d-flex align-items-center justify-content-center">
                <img
                  style="max-width: 50%; cursor: pointer"
                  src="https://res.cloudinary.com/oredev/image/upload/v1680286129/2023_web/Start-over-animation.gif"
                  alt=""
                  @click="selectAllTags(), scrollToTop()"
                />
              </div>
            </b-col>
          </b-row>
        </div> -->
        <!--    <div v-if="loadspeakers" class="row mt-5 justify-content-center">
          <Spinner></Spinner>
        </div> -->

        <!-- ALL SPEAKERS -->
        <b-row class="mt-5 mt-sm-4 mt-md-1">
          <!-- Speaker modal -->
          <b-modal no-fade id="my-modal-1" v-model="modalShow" ok-only>
            <div v-if="this.speakername" class="speaker-single">
              <b-row no-gutters class="d-block">
                <div class="">
                  <div class="col-sm-12 text-center">
                    <!-- <div id="scroll-anchor"></div> -->
                    <div v-if="speaker && speaker.speakerImageURL">
                      <img
                        class="mb-4 speaker-image speakerImage"
                        :key="myKey"
                        :src="speaker.speakerImageURL"
                        alt="speaker-face"
                        :class="
                          speaker.speakerSessionTags[0] === '.NET'
                            ? 'NET'
                            : speaker.speakerSessionTags[0]
                        "
                      />
                    </div>
                  </div>

                  <div v-if="speaker" class="col-sm-12 text-center">
                    <div class="p-3 pb-4 5 text-color-dark pt-0">
                      <h4 class="text-color-dark pb-2 speaker-name">
                        {{ this.speaker.speakerFirstName }}
                        {{ this.speaker.speakerLastName }}
                      </h4>
                      <a
                        v-if="speaker.speakerTwitter"
                        class="mb-2 d-block"
                        style="
                          cursor: pointer;
                          text-decoration: none !important;
                          color: #292929 !important;
                        "
                        :href="'http://twitter.com/' + speaker.speakerTwitter"
                      >
                        {{ speaker.speakerTwitter }}
                      </a>

                      <p class="text-left">
                        {{ speaker.speakerBiography }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="speaker && speaker.speakerSession">
                  <b-container>
                    <b-row class="mb-0 session">
                      <div class="col-12">
                        <h2>Sessions</h2>
                        <Toast
                          v-if="showingToast"
                          :message="toastMsg"
                          :duration="1500"
                          @hidden="showingToast = false"
                        />
                      </div>
                    </b-row>
                    <div
                      v-for="session in speaker.speakerSession"
                      v-bind:class="[setActiveSchedule(session.sId)]"
                      class="row session speaker-bg"
                      :key="session.index"
                    >
                      <!--      <div class="col-6 speaker">
                          {{ getDay(session.scheduleDay) }}
                          {{ session.scheduleTime }}
                        </div> -->
                      <div
                        v-on:click="toggleText(session.sId)"
                        class="col-7 col-sm-8 session-info pb-3"
                      >
                        <h5>
                          <span
                            class="session-title"
                            @click="sessionId = session.sId"
                            >{{ session.title }}</span
                          >
                        </h5>
                      </div>
                      <div class="col-5 col-sm-4 add-schedule speaker-bg">
                        <b-button
                          class="btn btn-add-schedule mt-3"
                          :class="
                            (setActiveSchedule(session.sId, true),
                            addOrRemove(session.sId) === 'Add' ? 'ml-3' : '')
                          "
                          @click="
                            setSchedule(session.sId, $event),
                              showToast(addOrRemove(session.sId))
                          "
                          >{{ addOrRemove(session.sId) }}</b-button
                        >
                        <span
                          class="fold-icons float-right mt-3"
                          @click="toggleText(session.sId)"
                        >
                          <i
                            :data-id="session.sId"
                            class="material-symbols-outlined hidden align-middle"
                            >keyboard_arrow_up</i
                          >
                          <i
                            :data-id="session.sId"
                            class="material-symbols-outlined align-middle"
                            >keyboard_arrow_down</i
                          ></span
                        >
                      </div>

                      <div
                        :data-id="session.sId"
                        class="col-12 session-text hidden"
                      >
                        <div v-if="getSessionById(session.sId)">
                          <p>
                            {{ getSessionById(session.sId).sessionDescription }}
                          </p>
                          <div
                            class="session-tag d-inline-block"
                            :class="
                              getSessionById(session.sId).sessionTagMain ===
                              '.NET'
                                ? 'tag-NET'
                                : 'tag-' +
                                  getSessionById(session.sId).sessionTagMain
                            "
                          >
                            <img
                              v-if="
                                getSessionById(session.sId).sessionTagMain ===
                                  'DATA' ||
                                getSessionById(session.sId).sessionTagMain ===
                                  'Security' ||
                                getSessionById(session.sId).sessionTagMain ===
                                  'Web' ||
                                getSessionById(session.sId).sessionTagMain ===
                                  'JVM'
                              "
                              src="https://res.cloudinary.com/oredev/image/upload/v1716803685/2024/Icons.svg/canvas.svg"
                              style="padding-bottom: 1px"
                            />
                            <img
                              v-else
                              src="https://res.cloudinary.com/oredev/image/upload/v1716803685/2024/Icons.svg/canvas_white.svg"
                              style="padding-bottom: 1px"
                            />
                            <span>{{
                              getSessionById(session.sId).sessionTagMain
                            }}</span>
                          </div>
                          <div class="session-tag bg-yellow d-inline-block">
                            <img
                              src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2024/Icons.svg/door.svg"
                              style="padding-bottom: 1px"
                            />
                            <span>
                              {{
                                getSessionById(session.sId).sessionScheduleRoom
                              }}
                            </span>
                          </div>
                          <div class="session-tag bg-yellow d-inline-block">
                            <img
                              src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2024/Icons.svg/calendar.svg"
                              style="padding-bottom: 1px"
                            />
                            <span>{{
                              getDay(
                                getSessionById(session.sId).sessionScheduleDay +
                                  ""
                              )
                            }}</span>
                          </div>
                          <div class="session-tag bg-yellow d-inline-block">
                            <img
                              src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2024/Icons.svg/clock.svg"
                              style="padding-bottom: 1px"
                            />
                            <span
                              >{{ getSessionById(session.sId).start }}
                              {{ getAmOrPm(getSessionById(session.sId).start) }}
                              {{ getSessionById(session.sId).end }} &#8594;
                              {{ getSessionById(session.sId).sessionlength }}
                              min</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--  <div class="col-12">
                       <h6>Key takeaways</h6>
                        <ul>
                          <li v-if="session.takeAway1">
                            {{ session.takeAway1 }}
                          </li>
                          <li v-if="session.takeAway2">
                            {{ session.takeAway2 }}
                          </li>
                          <li v-if="session.takeAway3">
                            {{ session.takeAway3 }}
                          </li>
                          <li v-if="session.takeAway4">
                            {{ session.takeAway4 }}
                          </li>
                        </ul>
                        <p class="text-color-dark">
                          {{ session.description }}
                        </p>
                        <pre>{{ session.url }}</pre>
                  </div> -->
                  </b-container>
                </div>
              </b-row>
            </div>
            <template #modal-footer>
              <p class="d-none">Empty footer</p>
            </template>
          </b-modal>

          <!-- SPEAKERS LOOP -->
          <b-col
            cols="6"
            md="4"
            lg="3"
            v-bind:class="[setVisibleSpeakers(speaker.speakerSessionTags)]"
            class="speaker-card text-center mt-5"
            v-for="(speaker, index) in speakers"
            :key="index"
          >
            <!--   <h1>{{ speaker.speakerSessionTags }}</h1>
            <br />
            <br />
            <br />
            <br />
            <br /> -->

            <!--  SINGLE SPEAKER IN LOOP  -->
            <div
              class="speaker-info pt-3 pb-3 pt-5 rounded d-flex flex-column justify-content-center"
              @click="showSpeaker(speaker.speakerURL)"
            >
              <!--             v-bind:to="{
                  name: 'Lineup-single',
                  params: { name: speaker.speakerURL },
                  query: { tags: $route.query.tags },
                }" -->

              <!-- <pre>{{ speaker.speakerSessionTags[ }}</pre> -->
              <div style="text-decoration: none !important">
                <div class="d-flex justify-content-center pointer">
                  <div v-if="speaker.speakerImagePuId">
                    <img
                      loading="lazy"
                      class="d-block speakerImage"
                      :src="speaker.speakerImageURL"
                      alt=""
                      :class="
                        speaker.speakerSession[0].sessionTagMain === '.NET'
                          ? 'NET'
                          : speaker.speakerSession[0].sessionTagMain
                      "
                    />
                  </div>
                </div>
                <div>
                  <p
                    class="speaker-name text-center text-color-dark pointer"
                    style="overflow-wrap: break-word"
                  >
                    {{ speaker.speakerFirstName }}
                    {{ speaker.speakerLastName }}
                  </p>
                  <p
                    class="speaker-name text-center text-color-dark pointer"
                    style="overflow-wrap: break-word; font-weight: 300"
                  >
                    {{ speaker.speakerSession[0].sessionTagMain }}
                  </p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-container fluid class="px-0 mt-4">
      <b-row no-gutters class="pb-1">
        <b-col cols="12" md="4">
          <b-img
            class="info-img pr-0 pr-md-1 pb-1 pb-md-0"
            src="https://res.cloudinary.com/oredev/image/upload/v1713356087/2024/e63a00cb2c904d7a78d46971971ab04f.jpg"
          ></b-img>
        </b-col>
        <b-col cols="12" md="4">
          <b-img
            class="info-img pr-0 pr-md-1 pb-1 pb-md-0"
            src="https://res.cloudinary.com/oredev/image/upload/v1713356086/2024/36a9f727cb779c2fe454347b34828808.jpg"
          ></b-img>
        </b-col>
        <b-col cols="12" md="4">
          <b-img
            class="info-img"
            src="https://res.cloudinary.com/oredev/image/upload/v1713356086/2024/04f46b9f2fb226018d7d5f37e7f602a8.jpg"
          ></b-img>
        </b-col>
      </b-row>
    </b-container>

    <b-img
      class="position-absolute d-none d-md-block"
      style="top: 256%; right: 2%; width: 15%"
      src="https://res.cloudinary.com/oredev/image/upload/v1712254780/2024/Blue_x.png"
    >
    </b-img>
    <b-img
      class="position-absolute d-none d-md-block"
      style="top: 125%; width: 12%; right: 2%"
      src="https://res.cloudinary.com/oredev/image/upload/v1712048064/2024/red-triangle.png"
    >
    </b-img>
    <b-img
      class="position-absolute d-none d-md-block"
      style="top: 228%; left: 2%; width: 10%"
      src="https://res.cloudinary.com/oredev/image/upload/v1714049018/2024/Asset_6.png"
    >
    </b-img>
    <b-img
      class="position-absolute d-none d-md-block"
      style="top: 165%; left: 2%; width: 15%"
      src="https://res.cloudinary.com/oredev/image/upload/v1715694256/2024/Asset_7_2x.png"
    >
    </b-img>
  </div>
</template>

<script>
import { tagsMixin } from "../mixins/tagsMixin";
import Spinner from "../components/Spinner";
import Toast from "../components/Toast";

$(document).on("click", "someyourContainer .dropdown-menu", function (e) {
  e.stopPropagation();
});

export default {
  name: "sessions",
  components: {
    Spinner,
    Toast,
  },
  watch: {
    $route(to, from) {
      if (to.path != from.path) {
        //this.loadspeakername = true;

        this.speakername = this.$route.params.name;

        this.modalShow = true;
        this.showingToast = false;

        /*      setTimeout(() => {
          $(".speaker-single").slideDown(200);
        }, 300);

        setTimeout(() => {
          $("#scroll-anchor").get(0).scrollIntoView({ behavior: "smooth" });
        }, 700);
        this.myKey++; */
        //this.getSpeaker();
      }
    },
    tags() {
      if (this.tags) {
        if (!this.$route.query.tags) this.selectAllTags();

        this.setTagsChoosen();
      }
    },
    speakers() {
      if (this.speakers.length) {
        this.loading = false;
      }
    },
  },
  computed: {
    speakers() {
      return this.$store.getters.getSpeakers;
    },
    speaker() {
      if (this.speakername && this.speakers) {
        return this.$store.getters.getSpeaker(this.speakername);
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      speakername: this.$route.params.name,
      //speaker: {},
      //speakers: [],
      schedule: [],
      day: "",
      loadspeakers: false,
      loadspeakername: true,
      doctitle: "",
      docimage: "",
      myKey: 0,
      isHovering: "",
      modalShow: false,
      modalShow2: false,
      activeTag: null,
      loading: true,
      showingToast: false,
      toastMsg: "",
    };
  },
  created() {
    const tagString = this.$route.query.tags;
    if (tagString) {
      const tagArray = tagString.split("_").filter((a) => a !== "");
      tagArray.forEach((a) => this.setTag(this.translateTag(a)));
    }
  },
  mixins: [tagsMixin],
  methods: {
    translateTag(tag) {
      if (tag === "Data") return "DATA";
      if (tag === "OFF-Track") return "OFF";
      if (tag === "Quality-Test") return "Quality & Test";
      if (tag === "NET") return ".NET";
      if (tag === "Cloud/DevOps" || tag === "Cloud-DevOps")
        return "Cloud & DevOps";
      if (tag === "Leadership-Management" || tag === "Leadership-MGMT")
        return "Leadership & MGMT";
      return tag;
    },
    getTag(tag) {
      if (tag == "DATA") {
        return "Data";
      }

      return tag;
    },
    getSessionById(id) {
      return this.$store.getters.getSessionID(id);
    },
    getAmOrPm(time) {
      const hour = parseInt(time.split(":")[0], 10); // Extrahera timmen och konvertera till ett tal
      return hour < 12 ? "am" : "pm";
    },

    showSpeaker(speakername) {
      this.modalShow = !this.modalShow;
      this.showingToast = false;

      this.speakername = speakername;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    getSpeaker: function () {
      if (this.speakername) {
        return;
        this.loadspeakername = true;

        /* this.axios
          .get("https://admin.oredev.org/plannedspeaker/" + this.speakername, {
            params: {
              //ID: 12345
            },
          })
          .then((response) => {
            const speaker = response.data.plannedspeakers;
            const speakersYear = speaker.filter((e) => {
              return e.conferencename === "Øredev 2023";
            });

            if (
              speakersYear.length &&
              speakersYear[0] &&
              speakersYear[0].speakerSession &&
              speakersYear[0].speakerSession.length
            ) {
              speakersYear[0].speakerSession.sort((a, b) => {
                const dayA = a.scheduleDay.toUpperCase(); // ignore upper and lowercase
                const dayB = b.scheduleDay.toUpperCase(); // ignore upper and lowercase
                if (dayA > dayB) {
                  return 1;
                }
                if (dayA < dayB) {
                  return -1;
                }

                // names must be equal
                return 0;
              });
            }

            this.speaker = speakersYear[0];

            if (
              this.speaker.speakerImagePuId ===
              "2022_speakers/erlend-oftedal-no"
            ) {
              this.speaker.speakerImageVersion = "";
              this.speaker.speakerImagePuId =
                this.speaker.speakerImagePuId + ".jpg";
            } else {
              this.speaker.speakerImageVersion =
                "v" + this.speaker.speakerImageVersion;
            }

            this.loadspeakername = false;
            this.myKey++;

            $(".speaker-single").slideDown(0);
            this.setDocTags();

            setTimeout(() => {
              $("#scroll-anchor").get(0).scrollIntoView({ behavior: "smooth" });
            }, 700);
            return;
          })
          .catch((error) => {
            console.log(error);
          }); */
      }
    },
    resetSpeaker: function () {
      $(".speaker-single").slideUp(200);
      //this.loadspeakername = true;
      this.speaker = {};
      this.speakername = "";
      this.$router.push({
        path: "/line-up",
        params: { name: "" },
        query: { tags: this.$route.query.tags },
      });
      this.setDocTags();
    },
    setVisibleSpeakers: function (tags) {
      let show = false;
      let tagschoosen = this.tagschoosen;
      let containsTag = false;
      if (tagschoosen && tagschoosen.length) {
        if (tags && tags.length) {
          tags.forEach((tag) => {
            if (tagschoosen.some((element) => this.fixTag(element) === tag)) {
              containsTag = true;
            }
          });
        }
      }

      if (containsTag) {
        show = true;
      }
      if (show) {
        return "show";
      } else {
        return "hidden";
      }
    },

    /*     setActiveSchedule: function (id, isButton) {
      console.log("%c 👊", "color: #007acc;", id);
      console.log("%c 👊", "color: #007acc;", isButton);

      const selSchedule = this.schedule;

      let containsId = false;
      if (selSchedule) {
        containsId = selSchedule.some((element) => element === id);
      }
      if (containsId && isButton) {
        return "btn-active";
      }

      if (containsId) {
        return "active";
      }
    }, 
    fetchSpeakers: function () {
      let that = this;
      this.axios
        .get("https://admin.oredev.org/plannedspeakers/Øredev 2023", {
          params: {
            //ID: 12345
          },
        })
        .then((response) => {
          let speakers = response.data.plannedspeakers.map(function (speaker) {
            if (speaker.speakerSessionTags) {
              speaker.speakerSessionTags = speaker.speakerSessionTags.map(
                function (tag) {
                  tag = that.fixTag(tag);
                  return tag;
                }
              );
            }

            return speaker;
          });

          speakers = speakers.map((speaker) => {
            if (
              speaker.speakerImagePuId === "2022_speakers/erlend-oftedal-no"
            ) {
              speaker.speakerImagePuId = speaker.speakerImagePuId + ".jpg";
            }
            return speaker;
          });

          this.speakers = speakers;

        })
        .catch((error) => {
          console.log(error);
        });
    },*/
    setStatusShowSpeaker: function () {
      if (this.tagschoosen.length === 0 && this.speakername) {
        this.status = "sessions";
      }
    },
    setDocTags: function () {
      this.doctitle = "Line up - " + this.$store.state.conferencename;
    },
    showToast(msg) {
      if (msg === "Add") this.toastMsg = "Removed from your schedule";
      else this.toastMsg = "Added to your schedule";
      this.showingToast = true;
    },
  },

  updated: function () {},
  mounted: function () {
    this.status = localStorage.getItem("sessionstatus") || "sessions";
    this.day = localStorage.getItem("day");
    this.schedule = JSON.parse(localStorage.getItem("schedule"));

    this.setStatusShowSpeaker();
    this.setDocTags();
  },
  beforeMount: function () {
    this.setUrlHasch("mounted");
    //this.fetchSpeakers();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";

.session-title {
  font-family: "Outfit";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: $text-dark;
}
.background {
  color: black;
  background: url("https://res.cloudinary.com/oredev/image/upload/v1715523769/2024/Asset_desktop.png");
  background-color: white;
  background-repeat: no-repeat;
  background-position: right;
  background-size: contain;
  height: 85vh;
}

@media screen and (max-width: 600px) {
  .background {
    background: none;
    height: 57vh;
    background-color: white;
    padding-top: 40px;
  }
}

.container-height {
  height: 100%;
}

.row-height {
  height: 150%;
}

@media screen and (min-width: 600px) {
  .row-height {
    height: 75%;
  }
}

@media screen and (min-width: 1200px) {
  .container-height {
    height: 50%;
  }
  .row-height {
    height: 130%;
  }
}
@media screen and (max-width: 600px) {
  .container-height {
    height: 0%;
  }
}

@media screen and (max-width: 500px) {
  .tags .cat-tag {
    flex: 1 1 auto !important;
  }
}

.bg-mobile {
  background-image: url("https://res.cloudinary.com/oredev/image/upload/v1715523769/2024/Asset_mobile.png");
  background-size: contain;
  height: 70vh;
  background-position: right;
  background-repeat: no-repeat;
  display: block;
  background-color: white;
  background-position: center;
}

@media only screen and (min-width: 601px) {
  .bg-mobile {
    display: none;
  }
}

h2,
h3,
h4,
h5 {
  font-family: Outfit, Geneva, Tahoma, sans-serif;
}

h2 {
  font-family: Outfit;
  font-size: 20px;
  font-weight: 300;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
}

.lineup .session .add-schedule i {
  @media (max-width: 767px) {
    margin-bottom: -10px;
  }
}

.bg-color {
  background: #efedea;
}

.open-in-new {
  text-align: right;
}

.speakerImage {
  margin-top: -90px;
  border-radius: 200px;
  width: 200px;
  border: 6px solid;
}

.Keynote,
.Architecture,
.Leadership,
.Leadership-MGMT {
  border-color: #e34407;
}

.Web,
.JVM {
  border-color: #de9fc2;
}
.AI,
.OFF {
  border-color: #3f875d;
}

.Security,
.Data,
.DATA {
  border-color: $yellow;
}
.Cloud,
.Cloud-DevOps,
.NET,
.Quality,
.Quality-Test {
  border-color: $blue;
}

// tagcolors
.tag-Keynote,
.tag-Architecture,
.tag-Leadership {
  background-color: #e34407;
  color: white;
}

.tag-Web,
.tag-JVM {
  background-color: #de9fc2;
}
.tag-AI,
.tag-OFF {
  background-color: #3f875d;
  color: white;
}

.tag-Security,
.tag-Data,
.tag-DATA {
  background-color: $yellow;
}
.tag-Cloud,
.tag-NET,
.tag-Quality {
  background-color: $blue;
  color: white;
}

@media screen and (max-width: 767px) {
  .speakerImage {
    margin-top: -130px;
    max-width: 150px;
  }
  .btn-add-schedule {
    padding-top: 7px !important;
    padding-bottom: 7px !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  .fold-icons {
    margin-top: 1.5rem !important;
  }
}

.speaker-bg {
  //background-color: #f2f2eb;
  color: black;
}

.speaker-name {
  overflow: hidden;
  white-space: nowrap;

  text-overflow: ellipsis;
  display: inline;
  line-height: 20px;
  font-family: Outfit;
  font-size: 20px;
  font-weight: 400;
  line-height: 31px;
  letter-spacing: 0em;
}

.speaker-name {
  margin-bottom: 5px;
  line-height: 1.5rem;
  overflow: inherit;
  white-space: inherit;
  display: block;
}

.speaker-image {
  height: auto;
  max-width: 80%;
  margin-top: 30px;
  position: relative;
  z-index: 99;
}

.btn-1 {
  background-color: #f2f2eb !important;
}

.space-man {
  width: 520px;
}
@media (max-width: 1500px) {
  .space-man {
    max-width: 320px;
  }
}
@media (max-width: 767px) {
  .btn-1 {
    width: 90px !important;
  }
  .speaker-image {
    max-width: 50%;
  }
  .space-man {
    max-width: 100%;
  }
}

.btn-1:hover {
  background: $orange !important;
  color: white !important;
}

.btn {
  display: inline-block;
  /*   border: 1px solid rgba(0, 128, 0, 0) !important;
  height: 44px;
  margin-bottom: 3px;
  padding: 10px; */
  //background-color: $green !important;
  //color: #fff !important;
  cursor: pointer;
}
.btn-add-schedule {
  padding-top: 2px;
  padding-bottom: 2px;
}
.btn-add-schedule:hover {
  background: #d89338 !important;
  border: 2px solid #d89338 !important;
}

/* .modal-body {
  background-color: misty-pink !important;
} */

.big-headline {
  font-family: Outfit;
  font-size: 1.5rem;
  font-weight: 900 !important;
  text-align: left;
  text-transform: uppercase;
}
@media only screen and (min-width: 600px) {
  .big-headline {
    font-size: 3rem;
  }
}

.blob-left {
  display: none;
  position: absolute;
  width: 5%;
  top: 4%;
  left: 9%;
}

@media only screen and (min-width: 600px) {
  .blob-left {
    display: block;
  }
}

.red-square {
  display: none;
  position: absolute;
  width: 10%;
  top: 23%;
  left: 9%;
}

@media only screen and (min-width: 600px) {
  .red-square {
    display: block;
  }
}

.session-tag {
  font-family: Outfit;
  font-size: 14px;
  font-weight: 300;
  line-height: 17.64px;
  letter-spacing: 0.05em;
  text-align: center;
  padding: 5px;
  padding: 4px 13px 4px 13px;
  border-radius: 5px;
  margin-bottom: 2px;
}

.select:hover {
  font-weight: 500;
}

.tag-name {
  text-transform: lowercase;
}
.tag-name::first-letter {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/views/Lineup.vue